module.exports = __webpack_public_path__ + "img/user-highlight.8709b29a.svg";